/*
 * EM Collection Cards — 3 boutons : Panier / Devis / Wishlist
 */
(function () {
  const QUOTE_KEY = 'em_quote_products';
  const WISH_KEY = 'em_wishlist_products';

  // Traduction des libellés Shopify natifs (filtres + sort)
  const I18N_MAP = {
    'Most relevant': 'Pertinence',
    'Best selling': 'Meilleures ventes',
    'Best-selling': 'Meilleures ventes',
    'Featured': 'En vedette',
    'Alphabetically, A-Z': 'Alphabétique A→Z',
    'Alphabetically, Z-A': 'Alphabétique Z→A',
    'Price, low to high': 'Prix croissant',
    'Price, high to low': 'Prix décroissant',
    'Date, old to new': 'Date : ancien → récent',
    'Date, new to old': 'Date : récent → ancien',
    'Availability': 'Disponibilité',
    'Price': 'Prix',
    'In stock': 'En stock',
    'Out of stock': 'Rupture',
    'Apply': 'Appliquer',
    'Reset': 'Réinitialiser',
    'Clear': 'Effacer',
    'Show more': 'Voir plus',
    'Show less': 'Voir moins',
  };

  function translateNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const txt = node.nodeValue.trim();
      if (I18N_MAP[txt]) node.nodeValue = node.nodeValue.replace(txt, I18N_MAP[txt]);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
    node.childNodes.forEach(translateNode);
  }

  // ----- Filtres custom : Matériau + Couleur sur TOUTE la collection -----
  const ACTIVE_FILTERS = { material: new Set(), color: new Set() };
  let _allProducts = null;   // cache des produits de la collection en cours
  let _collectionHandle = null;
  let _gridContainer = null;
  let _initialGridHTML = null;

  function getCollectionHandle() {
    const m = location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  async function fetchAllProducts(handle) {
    const all = [];
    let page = 1;
    while (page < 40) {
      const r = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
      if (!r.ok) break;
      const d = await r.json();
      const list = d.products || [];
      all.push(...list);
      if (list.length < 250) break;
      page++;
    }
    return all;
  }

  function aggregateTags(products, prefix) {
    const counts = new Map();
    for (const p of products) {
      const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(t => t.trim());
      for (const t of tags) {
        if (t.startsWith(prefix)) {
          const val = t.slice(prefix.length);
          counts.set(val, (counts.get(val) || 0) + 1);
        }
      }
    }
    return [...counts.entries()].sort((a, b) => b[1] - a[1]);
  }

  function getCardTagsFor(prefix) {
    if (_allProducts) return aggregateTags(_allProducts, prefix);
    // Fallback : tags des cards visibles
    const counts = new Map();
    document.querySelectorAll('[data-em-coll-card]').forEach(card => {
      (card.dataset.tags || '').split('|').forEach(t => {
        if (t.startsWith(prefix)) {
          const val = t.slice(prefix.length);
          counts.set(val, (counts.get(val) || 0) + 1);
        }
      });
    });
    return [...counts.entries()].sort((a, b) => b[1] - a[1]);
  }

  function buildEmFilter(kind, prefix, label, container) {
    const opts = getCardTagsFor(prefix);
    if (opts.length === 0) return null;

    const wrap = document.createElement('div');
    wrap.className = `em-filter em-filter--${kind}`;
    wrap.dataset.emFilter = kind;

    const activeCount = ACTIVE_FILTERS[kind].size;
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'em-filter-trigger';
    trigger.innerHTML = `<span>${label}${activeCount > 0 ? ` <span class="em-filter-trigger__count">${activeCount}</span>` : ''}</span>
      <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;

    const panel = document.createElement('div');
    panel.className = 'em-filter-panel';
    panel.innerHTML = opts.map(([val, n]) => {
      const checked = ACTIVE_FILTERS[kind].has(val);
      return `<label class="em-filter-opt${checked ? ' em-filter-opt--on' : ''}">
        <input type="checkbox" value="${escapeHtml(val)}" ${checked ? 'checked' : ''}>
        <span class="em-filter-opt__label">${escapeHtml(val)}</span>
        <span class="em-filter-opt__n">${n}</span>
      </label>`;
    }).join('');

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      // Ferme les autres dropdowns
      document.querySelectorAll('.em-filter[data-open], .em-sort[data-open]').forEach(d => {
        if (d !== wrap) d.removeAttribute('data-open');
      });
      if (wrap.hasAttribute('data-open')) wrap.removeAttribute('data-open');
      else wrap.setAttribute('data-open', '');
    });
    panel.addEventListener('change', (e) => {
      const cb = e.target.closest('input[type="checkbox"]');
      if (!cb) return;
      if (cb.checked) ACTIVE_FILTERS[kind].add(cb.value);
      else ACTIVE_FILTERS[kind].delete(cb.value);
      cb.closest('.em-filter-opt')?.classList.toggle('em-filter-opt--on', cb.checked);
      applyFilters();
      // Update trigger count
      const c = trigger.querySelector('.em-filter-trigger__count');
      const newCount = ACTIVE_FILTERS[kind].size;
      if (newCount === 0) { if (c) c.remove(); }
      else if (c) c.textContent = newCount;
      else trigger.querySelector('span').insertAdjacentHTML('beforeend', ` <span class="em-filter-trigger__count">${newCount}</span>`);
    });

    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    container.appendChild(wrap);
    return wrap;
  }

  function productMatches(p) {
    const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(t => t.trim());
    const matSet = ACTIVE_FILTERS.material;
    const colSet = ACTIVE_FILTERS.color;
    if (matSet.size > 0) {
      const ok = tags.some(t => t.startsWith('Matériau-') && matSet.has(t.slice('Matériau-'.length)));
      if (!ok) return false;
    }
    if (colSet.size > 0) {
      const ok = tags.some(t => t.startsWith('Couleur-') && colSet.has(t.slice('Couleur-'.length)));
      if (!ok) return false;
    }
    return true;
  }

  function isCoupDeCoeur(p) {
    const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(t => t.trim());
    return tags.some(t => /^coup[ _-]de[ _-]coeur$/i.test(t));
  }

  let _cardTemplateHTML = null;
  function captureTemplate() {
    if (_cardTemplateHTML) return;
    const sample = document.querySelector('.grid__item');
    if (sample) _cardTemplateHTML = sample.outerHTML;
  }

  function renderProductCardFromTemplate(p, idx) {
    if (!_cardTemplateHTML) return '';
    const v = p.variants?.[0] || {};
    const img = p.images?.[0]?.src || '';
    const url = `/products/${p.handle}`;
    const cents = Math.round(parseFloat(v.price) * 100);
    const cheap = cents > 0 && cents < 5000;
    const coup = isCoupDeCoeur(p);
    const tagsAttr = (Array.isArray(p.tags) ? p.tags : String(p.tags||'').split(',').map(t=>t.trim())).join('|');

    // Parse le template HTML
    const tmp = document.createElement('div');
    tmp.innerHTML = _cardTemplateHTML;
    const li = tmp.firstElementChild;
    if (!li) return '';
    li.setAttribute('style', `--animation-order: ${idx + 1};`);

    const art = li.querySelector('.em-coll-card');
    if (!art) return '';
    art.dataset.productId = p.id;
    art.dataset.variantId = v.id || '';
    art.dataset.handle = p.handle;
    art.dataset.title = p.title;
    art.dataset.type = p.product_type || '';
    art.dataset.unitPrice = cents;
    art.dataset.image = img;
    art.dataset.tags = tagsAttr;

    // Image
    const imgEl = art.querySelector('.em-coll-card__media img');
    if (imgEl) {
      imgEl.src = img;
      imgEl.alt = p.title;
    }
    const linkMedia = art.querySelector('.em-coll-card__media');
    if (linkMedia) linkMedia.setAttribute('href', url);

    // Badges
    let badgesWrap = art.querySelector('.em-coll-card__badges');
    if (coup || cheap) {
      if (!badgesWrap) {
        badgesWrap = document.createElement('div');
        badgesWrap.className = 'em-coll-card__badges';
        art.insertBefore(badgesWrap, art.querySelector('.em-coll-card__qty-badge') || art.querySelector('.em-coll-card__body'));
      }
      badgesWrap.innerHTML = `${coup ? '<span class="em-coll-card__badge em-coll-card__badge--love">Coup de cœur</span>' : ''}${cheap ? '<span class="em-coll-card__badge em-coll-card__badge--cheap">Petit prix</span>' : ''}`;
    } else if (badgesWrap) {
      badgesWrap.remove();
    }

    // Qty badge reset
    const qtyBadge = art.querySelector('.em-coll-card__qty-badge');
    if (qtyBadge) { qtyBadge.hidden = true; const n = qtyBadge.querySelector('[data-em-coll-qty-num]'); if (n) n.textContent = '0'; }

    // Title
    const titleA = art.querySelector('.em-coll-card__title a');
    if (titleA) { titleA.href = url; titleA.textContent = p.title; }

    // Price
    const priceEl = art.querySelector('.em-coll-card__price');
    if (priceEl) priceEl.textContent = new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);

    return li.outerHTML;
  }

  function applyFilters() {
    if (!_allProducts || !_gridContainer) {
      // Fallback : hide visible cards
      document.querySelectorAll('[data-em-coll-card]').forEach(card => {
        const li = card.closest('.grid__item') || card;
        const tags = (card.dataset.tags || '').split('|');
        const cardMats = tags.filter(t => t.startsWith('Matériau-')).map(t => t.slice('Matériau-'.length));
        const cardCols = tags.filter(t => t.startsWith('Couleur-')).map(t => t.slice('Couleur-'.length));
        const matMatch = ACTIVE_FILTERS.material.size === 0 || cardMats.some(m => ACTIVE_FILTERS.material.has(m));
        const colMatch = ACTIVE_FILTERS.color.size === 0 || cardCols.some(c => ACTIVE_FILTERS.color.has(c));
        li.style.display = (matMatch && colMatch) ? '' : 'none';
      });
      return;
    }

    // Re-render la grille entière depuis le cache
    const noFilter = ACTIVE_FILTERS.material.size === 0 && ACTIVE_FILTERS.color.size === 0;
    if (noFilter && _initialGridHTML) {
      // Restaure le HTML initial (avec pagination Shopify)
      _gridContainer.innerHTML = _initialGridHTML;
      return;
    }
    const matching = _allProducts.filter(productMatches);
    captureTemplate();
    _gridContainer.innerHTML = matching.length > 0
      ? matching.map((p, i) => renderProductCardFromTemplate(p, i)).join('')
      : '<li class="grid__item" style="grid-column:1/-1;text-align:center;padding:40px;color:#5A6A64;"><p>Aucun produit ne correspond à votre sélection.</p></li>';
    // Re-déclenche les animations scroll-trigger (Dawn)
    _gridContainer.querySelectorAll('.scroll-trigger.animate--slide-in').forEach(el => {
      el.classList.add('scroll-trigger--offscreen');
      requestAnimationFrame(() => el.classList.remove('scroll-trigger--offscreen'));
    });
    // Maj du compteur si on a un élément
    const cntEl = document.querySelector('[data-em-filter-count]');
    if (cntEl) cntEl.textContent = `${matching.length} produits`;
  }

  async function injectCustomFilters() {
    // Cherche d'abord le form, sinon le wrapper qui contient les filtres
    let facetsForm = document.querySelector('#FacetFiltersForm, .facets, .facets-container form, form[id*="FacetFilters"]');
    if (!facetsForm) {
      // Dernier recours : la zone qui contient .facets__disclosure
      const anyFacet = document.querySelector('.facets__disclosure, .facet-filters__field');
      if (anyFacet) facetsForm = anyFacet.parentElement;
    }
    if (!facetsForm) {
      console.warn('[EM] facetsForm introuvable');
      return;
    }
    if (facetsForm.dataset.emFiltersInjected) return;
    facetsForm.dataset.emFiltersInjected = '1';

    // Détection collection + fetch ALL products
    _collectionHandle = getCollectionHandle();
    _gridContainer = document.querySelector('#product-grid, .product-grid, [id*="product-grid"], ul[id*="product-grid"]');
    if (_gridContainer) {
      _initialGridHTML = _gridContainer.innerHTML;
      captureTemplate();
    }

    if (_collectionHandle && _collectionHandle !== 'all') {
      try { _allProducts = await fetchAllProducts(_collectionHandle); }
      catch (e) { console.warn('[EM] fetchAllProducts fail', e); _allProducts = null; }
    }

    let container = facetsForm.querySelector('[data-em-filters-container]');
    if (!container) {
      container = document.createElement('div');
      container.dataset.emFiltersContainer = '';
      container.className = 'em-filters-row';
      // Insère juste après la 1ère disclosure (à côté de Prix)
      const firstDisclosure = facetsForm.querySelector('.facets__disclosure');
      if (firstDisclosure && firstDisclosure.parentElement) {
        firstDisclosure.parentElement.insertBefore(container, firstDisclosure.nextSibling);
      } else {
        const sortZone = facetsForm.querySelector('.facet-filters__field, .em-sort');
        if (sortZone) facetsForm.insertBefore(container, sortZone);
        else facetsForm.appendChild(container);
      }
    }
    container.innerHTML = '';
    buildEmFilter('material', 'Matériau-', 'Matériau', container);
    buildEmFilter('color', 'Couleur-', 'Couleur', container);

    if (!window._emFilterCloseSet) {
      document.addEventListener('click', (e) => {
        document.querySelectorAll('.em-filter[data-open]').forEach(d => {
          if (!d.contains(e.target)) d.removeAttribute('data-open');
        });
      });
      window._emFilterCloseSet = true;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function buildCustomSort() {
    document.querySelectorAll('select[name="sort_by"], select#SortBy').forEach(sel => {
      if (sel.dataset.emCustomized) return;
      sel.dataset.emCustomized = '1';
      const parent = sel.parentElement;

      const wrap = document.createElement('div');
      wrap.className = 'em-sort';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'em-sort-trigger';
      const labelSpan = document.createElement('span');
      labelSpan.className = 'em-sort-trigger__label';
      const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      caret.setAttribute('viewBox', '0 0 24 24');
      caret.setAttribute('fill', 'none');
      caret.setAttribute('stroke', 'currentColor');
      caret.setAttribute('stroke-width', '2.4');
      caret.setAttribute('stroke-linecap', 'round');
      caret.setAttribute('stroke-linejoin', 'round');
      caret.innerHTML = '<polyline points="6 9 12 15 18 9"/>';
      trigger.appendChild(labelSpan);
      trigger.appendChild(caret);

      const panel = document.createElement('div');
      panel.className = 'em-sort-panel';

      function updateLabel() {
        const opt = sel.options[sel.selectedIndex];
        labelSpan.textContent = opt ? opt.textContent.trim() : 'Trier';
      }
      function refreshOptions() {
        panel.innerHTML = '';
        Array.from(sel.options).forEach(opt => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'em-sort-option' + (opt.selected ? ' em-sort-option--active' : '');
          btn.dataset.value = opt.value;
          btn.innerHTML = `<span class="em-sort-option__label">${opt.textContent.trim()}</span><span class="em-sort-option__check"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>`;
          btn.addEventListener('click', () => {
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            wrap.removeAttribute('data-open');
            updateLabel();
            refreshOptions();
          });
          panel.appendChild(btn);
        });
      }
      updateLabel();
      refreshOptions();

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (wrap.hasAttribute('data-open')) wrap.removeAttribute('data-open');
        else wrap.setAttribute('data-open', '');
      });
      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) wrap.removeAttribute('data-open');
      });

      wrap.appendChild(trigger);
      wrap.appendChild(panel);
      parent.insertBefore(wrap, sel);
      sel.style.display = 'none';

      sel.addEventListener('change', () => { updateLabel(); refreshOptions(); });
    });
  }

  function hideAvailabilityFilter() {
    document.querySelectorAll('[name="filter.v.availability"]').forEach(input => {
      // Remonte au conteneur du filtre (details / disclosure)
      const container = input.closest('.facets__disclosure, .facets__disclosure-vertical, .mobile-facets__details, details, .facets__details');
      if (container) container.style.display = 'none';
    });
  }

  // ============== Pills sous-catégorie ==============
  const SUBCAT_BY_HANDLE = {
    'cat-assises': ['Canapé','Chaise','Fauteuil','Tabouret','Pouf','Banc'],
    'cat-tables': ['Table à manger','Table basse','Table de chevet','Table de bar','Bureau','Console','Desserte'],
    'cat-etageres-et-rangements': ['Meuble TV','Meuble d\'entrée','Bibliothèque','Buffet','Commode','Dressing','Armoire','Étagère','Porte manteau','Secrétaire'],
    'cat-chambre': ['Matelas','Sommier','Lit','Housse de couette','Drap housse','Oreiller','Couette','Parure de lit','Commode','Armoire'],
    'cat-fenetre': ['Tringle','Support tringle','Rideau','Voilage','Store'],
    'cat-mobilier-dexterieur': ['Lit extérieur','Chaise longue','Table extérieur','Canapé extérieur','Fauteuil extérieur','Chaise extérieur'],
    'cat-petits-electros': ['Cafetière','Blender & Robot','Bouilloire','Aspirateur','Fer à repasser','TV','Ventilateur','Cuiseur'],
    'cat-gros-electros': ['Réfrigérateur & Congélateur','Hotte','Four','Lave-vaisselle','Lave-linge','Plaque cuisson'],
    'cat-decorations-a-poser': ['Bougie','Vase','Lanterne','Statue & animal','Miroir','Plateau','Pot','Boîte déco','Panier','Vide poche','Plante','Paravent','Pulvérisateur'],
    'cat-decorations-murales': ['Tableau','Miroir','Horloge','Patère','Étagère murale','Déco murale'],
    'cat-luminaires': ['Suspension','Lampadaire','Applique','Spot','Ampoule','Lampe à poser','Plafonnier'],
    'cat-linge-de-maison': ['Coussin','Plaid','Tapis','Couette','Drap','Oreiller','Parure de lit','Rideau & Voilage'],
    'cat-salle-de-bain': ['Serviette/Gant','Tapis','Distributeur savon','Porte savon','Brosse WC','Pot brosse à dent','Gobelet','Miroir','Abattant WC'],
    'cat-cuisine': ['Mug & Tasse','Bol','Assiette','Verre','Carafe','Set de table','Corbeille','Poêle','Casserole','Faitout','Planche à découper','Pot ustensile'],
    'cat-cuisine-generique': ['Mug & Tasse','Bol','Assiette','Verre','Carafe','Couteau','Couverts','Poubelle','Plateau','Ustensiles','Planche','Salière & Poivrière','Saladier'],
    'cat-salle-de-bain-generique': ['Porte brosse à dent','Porte serviette / Crochet','Echelle serviette','Rangement','Panier','Abattant WC','Miroir','Rideau de douche','Distributeur savon','Serviette','Gobelet'],
    'cat-plantes-artificielles': ['Palmier','Bananier','Monstera','Bambou','Tige artificielle','Feuillage','Plante','Fagot'],
    'cat-produits-menagers': ['Liquide vaisselle','Nettoyant ménager','Nettoyant WC','Eau de javel','Insecticide','Lessive'],
    'cat-outillage-et-bricolage': ['Déboucheur','Pâte à fixer','Pince & Cheville','Adhésif & Ruban','Sécurité','Lampe LED','Douille'],
  };

  function buildSubcatPills() {
    const handle = getCollectionHandle();
    if (!handle) return;
    const subcats = SUBCAT_BY_HANDLE[handle];
    if (!subcats || !subcats.length) return;

    const bar = document.querySelector('.em-fs-bar');
    if (!bar || bar.dataset.emSubcatsBuilt) return;
    bar.dataset.emSubcatsBuilt = '1';

    const pillsWrap = document.createElement('div');
    pillsWrap.className = 'em-subcat-pills';

    // Détermine l'URL params actif (pour highlight)
    const urlParams = new URLSearchParams(location.search);
    const activeMf = urlParams.get('filter.p.m.custom.sous_categorie') || '';

    // Pill "Tous"
    const allPill = document.createElement('a');
    allPill.className = 'em-subcat-pill' + (!activeMf ? ' em-subcat-pill--active' : '');
    allPill.href = `/collections/${handle}`;
    allPill.textContent = 'Tous';
    pillsWrap.appendChild(allPill);

    subcats.forEach(sc => {
      const a = document.createElement('a');
      const isActive = activeMf === sc;
      a.className = 'em-subcat-pill' + (isActive ? ' em-subcat-pill--active' : '');
      a.href = `/collections/${handle}?filter.p.m.custom.sous_categorie=${encodeURIComponent(sc)}`;
      a.textContent = sc;
      pillsWrap.appendChild(a);
    });

    // Insère après le bouton Filtrer
    const filterBtn = bar.querySelector('.em-fs-btn');
    if (filterBtn) filterBtn.insertAdjacentElement('afterend', pillsWrap);
    else bar.appendChild(pillsWrap);
  }

  // ============== Drawer "Filtrer et trier" ==============
  function buildFilterDrawer() {
    if (document.querySelector('[data-em-fs-drawer]')) return;
    const facetsForm = document.querySelector('#FacetFiltersForm, .facets__form, form[id*="FacetFilters"]');
    if (!facetsForm) return;

    document.body.classList.add('em-has-drawer');

    // Compteur de filtres actifs
    const activeCount = facetsForm.querySelectorAll('input:checked, input[type="number"][value]:not([value=""])').length;

    // Bouton + barre
    const bar = document.createElement('div');
    bar.className = 'em-fs-bar';
    bar.innerHTML = `
      <button type="button" class="em-fs-btn" data-em-fs-open>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>
        Filtrer et trier
        <span class="em-fs-count-badge" data-em-fs-count ${activeCount === 0 ? 'hidden' : ''}>${activeCount}</span>
      </button>
    `;
    // Insert avant le grid
    const insertPoint = document.querySelector('.product-grid-container, #ProductGridContainer') || facetsForm.parentElement;
    insertPoint.parentElement.insertBefore(bar, insertPoint);

    // Drawer
    const drawer = document.createElement('div');
    drawer.className = 'em-fs-drawer';
    drawer.dataset.emFsDrawer = '';
    drawer.innerHTML = `
      <div class="em-fs-drawer__backdrop" data-em-fs-close></div>
      <aside class="em-fs-drawer__panel">
        <header class="em-fs-drawer__head">
          <h2 class="em-fs-drawer__title">Filtrer et trier</h2>
          <button type="button" class="em-fs-drawer__close" data-em-fs-close aria-label="Fermer">×</button>
        </header>
        <div class="em-fs-drawer__body" data-em-fs-body></div>
        <footer class="em-fs-drawer__foot">
          <button type="button" class="em-fs-foot-btn em-fs-foot-btn--clear" data-em-fs-clear>Tout effacer</button>
          <button type="button" class="em-fs-foot-btn em-fs-foot-btn--apply" data-em-fs-apply>Appliquer</button>
        </footer>
      </aside>
    `;
    document.body.appendChild(drawer);

    // Construit les sections
    const body = drawer.querySelector('[data-em-fs-body]');
    populateDrawerSections(body, facetsForm);

    // Wire events
    bar.querySelector('[data-em-fs-open]').addEventListener('click', () => {
      // Re-sync le drawer avec l'état actuel du form natif
      populateDrawerSections(body, facetsForm);
      drawer.classList.add('em-fs-drawer--open');
      document.body.style.overflow = 'hidden';
    });
    drawer.querySelectorAll('[data-em-fs-close]').forEach(b => b.addEventListener('click', () => {
      drawer.classList.remove('em-fs-drawer--open');
      document.body.style.overflow = '';
    }));
    drawer.querySelector('[data-em-fs-clear]').addEventListener('click', () => {
      drawer.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(i => { i.checked = false; });
      drawer.querySelectorAll('input[type="number"]').forEach(i => { i.value = ''; });
    });
    drawer.querySelector('[data-em-fs-apply]').addEventListener('click', () => {
      // Sync drawer values → facetsForm puis submit
      syncDrawerToForm(body, facetsForm);
      drawer.classList.remove('em-fs-drawer--open');
      document.body.style.overflow = '';
      // Submit Shopify
      if (typeof window.FacetFiltersForm !== 'undefined' || facetsForm.tagName === 'FORM') {
        facetsForm.submit?.() || facetsForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  function populateDrawerSections(body, facetsForm) {
    body.innerHTML = '';

    // 1. Sections pour chaque filtre (details.facets__disclosure-vertical, .facets__disclosure)
    const disclosures = facetsForm.querySelectorAll('details.facets__disclosure-vertical, details.facets__disclosure, details[class*="facets"]');
    let firstSection = true;
    const seen = new Set();
    disclosures.forEach(disc => {
      const label = disc.querySelector('.facets__summary-label, .facets__heading')?.textContent.trim() || '';
      if (!label || seen.has(label)) return;
      seen.add(label);
      // Skip availability (déjà masqué)
      if (/availability|disponibili/i.test(label)) return;

      const section = document.createElement('div');
      section.className = 'em-fs-section';
      if (firstSection) { section.setAttribute('data-open', ''); firstSection = false; }
      const head = document.createElement('button');
      head.type = 'button';
      head.className = 'em-fs-section__head';
      head.innerHTML = `<span>${escapeHtml(label)}</span><span class="em-fs-section__chev"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>`;
      head.addEventListener('click', () => {
        if (section.hasAttribute('data-open')) section.removeAttribute('data-open');
        else section.setAttribute('data-open', '');
      });
      const secBody = document.createElement('div');
      secBody.className = 'em-fs-section__body';

      // Type de filtre : price range ou liste options
      const priceInputs = disc.querySelectorAll('input[type="number"][name*="filter.v.price"]');
      if (priceInputs.length > 0) {
        // Prix range
        const min = priceInputs[0]?.placeholder || priceInputs[0]?.dataset.min || 0;
        const max = priceInputs[1]?.placeholder || priceInputs[1]?.dataset.max || '';
        const valMin = priceInputs[0]?.value || '';
        const valMax = priceInputs[1]?.value || '';
        secBody.innerHTML = `
          <div class="em-fs-price">
            <p class="em-fs-price-info">Le prix le plus élevé est ${max} €</p>
            <div class="em-fs-price-row">
              <div class="em-fs-price-field">
                <input type="number" placeholder="${escapeHtml(min)}" value="${escapeHtml(valMin)}" data-em-fs-link="${priceInputs[0]?.name || ''}">
                <span class="em-fs-price-field__currency">€</span>
              </div>
              <span class="em-fs-price-sep">—</span>
              <div class="em-fs-price-field">
                <input type="number" placeholder="${escapeHtml(max)}" value="${escapeHtml(valMax)}" data-em-fs-link="${priceInputs[1]?.name || ''}">
                <span class="em-fs-price-field__currency">€</span>
              </div>
            </div>
          </div>
        `;
      } else {
        // Liste checkbox
        const opts = disc.querySelectorAll('input[type="checkbox"]');
        const seenVals = new Set();
        opts.forEach(opt => {
          const val = opt.value;
          const key = `${opt.name}=${val}`;
          if (seenVals.has(key)) return;
          seenVals.add(key);
          const lbl = opt.closest('label')?.querySelector('.facet-checkbox__text-label, .facets-layout-list__label')?.firstChild?.textContent.trim()
                  || opt.parentElement?.textContent.trim().replace(/\d+\s*$/,'').trim()
                  || val;
          const cnt = opt.closest('label')?.textContent.match(/\((\d+)\)/)?.[1]
                  || opt.parentElement?.textContent.match(/\d+/)?.[0]
                  || '';
          const checked = opt.checked ? 'checked' : '';
          const row = document.createElement('label');
          row.className = 'em-fs-opt';
          row.innerHTML = `
            <span class="em-fs-opt__lbl">
              <input type="checkbox" name="${escapeHtml(opt.name)}" value="${escapeHtml(val)}" ${checked}>
              <span>${escapeHtml(lbl)}</span>
            </span>
            ${cnt ? `<span class="em-fs-opt__count">${cnt}</span>` : ''}
          `;
          secBody.appendChild(row);
        });
      }
      section.appendChild(head);
      section.appendChild(secBody);
      body.appendChild(section);
    });

    // 2. Section "Trier par"
    const sortSel = facetsForm.querySelector('select[name="sort_by"], select#SortBy') || document.querySelector('select[name="sort_by"], select#SortBy');
    if (sortSel) {
      const section = document.createElement('div');
      section.className = 'em-fs-section';
      const head = document.createElement('button');
      head.type = 'button';
      head.className = 'em-fs-section__head';
      head.innerHTML = `<span>Trier par</span><span class="em-fs-section__chev"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>`;
      head.addEventListener('click', () => {
        if (section.hasAttribute('data-open')) section.removeAttribute('data-open');
        else section.setAttribute('data-open', '');
      });
      const secBody = document.createElement('div');
      secBody.className = 'em-fs-section__body';
      Array.from(sortSel.options).forEach(opt => {
        const checked = opt.selected ? 'checked' : '';
        const row = document.createElement('label');
        row.className = 'em-fs-opt';
        row.innerHTML = `
          <span class="em-fs-opt__lbl">
            <input type="radio" name="em-fs-sort" value="${escapeHtml(opt.value)}" ${checked}>
            <span>${escapeHtml(opt.textContent.trim())}</span>
          </span>
        `;
        secBody.appendChild(row);
      });
      section.appendChild(head);
      section.appendChild(secBody);
      // « Trier par » en premier et ouvert : les clients trient surtout par
      // prix (Milène 2026-10-12). Les filtres restent repliés en dessous.
      body.querySelectorAll('.em-fs-section[data-open]').forEach((s) => s.removeAttribute('data-open'));
      section.setAttribute('data-open', '');
      body.insertBefore(section, body.firstChild);
    }
  }

  function syncDrawerToForm(body, facetsForm) {
    // Checkbox/radio match by name+value
    facetsForm.querySelectorAll('input[type="checkbox"]').forEach(formInput => {
      const drawerInput = body.querySelector(`input[type="checkbox"][name="${CSS.escape(formInput.name)}"][value="${CSS.escape(formInput.value)}"]`);
      if (drawerInput) formInput.checked = drawerInput.checked;
    });
    // Price
    body.querySelectorAll('input[type="number"][data-em-fs-link]').forEach(drawerIn => {
      const name = drawerIn.dataset.emFsLink;
      const formIn = facetsForm.querySelector(`input[type="number"][name="${CSS.escape(name)}"]`);
      if (formIn) formIn.value = drawerIn.value;
    });
    // Sort
    const sortRadio = body.querySelector('input[name="em-fs-sort"]:checked');
    if (sortRadio) {
      const sortSel = facetsForm.querySelector('select[name="sort_by"], select#SortBy') || document.querySelector('select[name="sort_by"]');
      if (sortSel) {
        sortSel.value = sortRadio.value;
        sortSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function translatePage() {
    hideAvailabilityFilter();
    // buildCustomSort(); // remplacé par le drawer
    buildFilterDrawer();
    buildSubcatPills();
    // injectCustomFilters();
    const targets = document.querySelectorAll('.facets, .facets__form, .mobile-facets, .sort-by, select#SortBy, [name="filter.v.availability"], [name="filter.v.price.gte"], [name="filter.v.price.lte"]');
    targets.forEach(translateNode);
    // Aussi les options du select Sort
    document.querySelectorAll('select option').forEach(opt => {
      if (I18N_MAP[opt.textContent.trim()]) opt.textContent = I18N_MAP[opt.textContent.trim()];
    });
    // Labels parents
    document.querySelectorAll('.facets__summary, .facets__heading, .facets__label, .facet-checkbox__text-label, .facet-filters__label, .mobile-facets__heading').forEach(el => {
      const txt = el.textContent.trim();
      const m = Object.keys(I18N_MAP).find(k => txt === k);
      if (m) {
        // Remplace uniquement les nodes de texte pour ne pas casser les icônes
        translateNode(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translatePage);
  } else {
    translatePage();
  }
  // Re-traduire après filter updates (Shopify recharge le DOM)
  const obs = new MutationObserver(() => translatePage());
  obs.observe(document.body, { childList: true, subtree: true });

  function loadList(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; }
    catch (e) { return []; }
  }
  function saveList(key, list) { localStorage.setItem(key, JSON.stringify(list)); }

  function showToast(msg, link, linkText) {
    let t = document.querySelector('.em-coll-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'em-coll-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = `${msg}${link ? ` <a href="${link}">${linkText}</a>` : ''}`;
    t.classList.remove('em-coll-toast--show');
    void t.offsetWidth;
    t.classList.add('em-coll-toast--show');
    clearTimeout(t._tmr);
    t._tmr = setTimeout(() => t.classList.remove('em-coll-toast--show'), 3200);
  }

  function flashBtn(btn) {
    btn.classList.remove('em-coll-card__action--flash');
    void btn.offsetWidth;
    btn.classList.add('em-coll-card__action--flash');
  }

  document.addEventListener('click', async (e) => {
    const card = e.target.closest('.em-coll-card');
    if (!card) return;

    // Panier
    const cartBtn = e.target.closest('[data-em-coll-cart]');
    if (cartBtn) {
      e.preventDefault();
      cartBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(card.dataset.variantId, 10), quantity: 1 }] }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          alert('Erreur : ' + (err.description || res.statusText));
          cartBtn.disabled = false;
          return;
        }
        flashBtn(cartBtn);
        showToast(`✓ « ${card.dataset.title} » ajouté au panier`, '/cart', 'Voir le panier →');
      } catch (err) {
        alert('Erreur : ' + err.message);
      } finally {
        cartBtn.disabled = false;
      }
      return;
    }

    // Devis
    const quoteBtn = e.target.closest('[data-em-coll-quote]');
    if (quoteBtn) {
      e.preventDefault();
      const list = loadList(QUOTE_KEY);
      const id = card.dataset.productId;
      const idx = list.findIndex(x => x.product_id === id);
      if (idx >= 0) {
        list[idx].qty = (list[idx].qty || 1) + 1;
      } else {
        list.push({
          product_id: id,
          variant_id: card.dataset.variantId,
          handle: card.dataset.handle,
          title: card.dataset.title,
          type: card.dataset.type,
          unit_price: parseInt(card.dataset.unitPrice, 10),
          image: card.dataset.image,
          qty: 1,
          savedAt: Math.floor(Date.now() / 1000),
        });
      }
      saveList(QUOTE_KEY, list);
      flashBtn(quoteBtn);
      showToast(`📄 « ${card.dataset.title} » ajouté au devis`);
      return;
    }

    // Wishlist : fenêtre d'ajout aux wishlists du compte client (ERP), 2026-10-08.
    // Plus d'écriture dans la liste locale. Ouverture synchrone (bloqueurs de popup).
    const wishBtn = e.target.closest('[data-em-coll-wish]');
    if (wishBtn) {
      e.preventDefault();
      if (window.EMWishlistERP) {
        window.EMWishlistERP.open({
          product_id: card.dataset.productId,
          variant_id: card.dataset.variantId,
          handle: card.dataset.handle,
          title: card.dataset.title,
          type: card.dataset.type,
          unit_price: parseInt(card.dataset.unitPrice, 10),
          image: card.dataset.image,
          qty: 1,
        });
        flashBtn(wishBtn);
      }
      return;
    }
  });
})();
